'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'

// walrus
import Text from '@components/kit/text'
import Box from '@components/kit/box'
import { useNavigate } from 'react-router-dom'
import { useOpportunityStore } from '@store/Opportunity'
import Pressable from '@components/kit/pressable'
import Loading from '@components/kit/loading'
import Modal from '@components/kit/modal'
import { EditOpportunity } from './edit-opportunity/edit-opportunity.web'
import { useParams } from 'react-router'

/* -----------------------------------------------------------------------------
 * Custom Opportunity
 * -------------------------------------------------------------------------- */

export function UniqueOpportunity() {
  const navigate = useNavigate()
  const { ruleName } = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [selectedRuleName, setSelectedRuleName] = useState<string | null>(null)

  const uniqueRules = useOpportunityStore(state => state.uniqueRules)
  const { fetchOpportunitiesUniqueRules } = useOpportunityStore.getState()

  const handleOnClose = () => {
    setSelectedRuleName(null)
    if (ruleName) {
      navigate('/opportunities/unique')
    }
  }

  const handleRuleSelection = (ruleName: string) => {
    setSelectedRuleName(ruleName)
    navigate(`/opportunities/unique/${ruleName}`)
  }

  useEffect(() => {
    if (isLoading) {
      fetchOpportunitiesUniqueRules().then(() => {
        setIsLoading(false)
      })
    }
  }, [isLoading, fetchOpportunitiesUniqueRules])

  useEffect(() => {
    if (!selectedRuleName) {
      setIsLoading(true)
    }
  }, [selectedRuleName])

  useEffect(() => {
    if (ruleName) {
      fetchOpportunitiesUniqueRules().then(() => {
        setSelectedRuleName(ruleName)
      })
    }
  }, [ruleName])

  return (
    <Box mt='16'>
      {(uniqueRules ?? []).map((uniqueRule, index) => (
        <Box key={index} mb='16' gap='08'>
          <Pressable onPress={() => handleRuleSelection(uniqueRule.rule_name)}>
            <Text font='text.14.medium' textColor='walrusBlue200'>
              {uniqueRule.rule_name}
            </Text>
          </Pressable>
        </Box>
      ))}
      {isLoading && <Loading size='large' />}
      <Modal
        open={!!selectedRuleName}
        onRequestClose={handleOnClose}
        padding='24'
      >
        <EditOpportunity
          ruleName={selectedRuleName || ''}
          onClose={handleOnClose}
        />
      </Modal>
    </Box>
  )
}
